/**
 * addClass.js
 *
 * @Author: apple
 * @Date: 2018/4/13 21:57
 */

const addClass = (element, className) => {
    if (element) {
        let originCls = element.className;
        if (!originCls.match(className)) {
            originCls += ` ${className}`;
        }
        element.className = originCls;
    }
};

const deleteClass = (element, className) => {
    if (element) {
        let originCls = element.className;
        if (originCls.match(className)) {
            originCls = originCls.split(` ${className}`)[0];
        }
        element.className = originCls;
    }
};

export { addClass, deleteClass };



// WEBPACK FOOTER //
// ./src/util/operateClass.js